import SalonArtistGrid from "./SalonArtistGrid";
import SalonArtistGridItem from "./SalonArtistGridItem";

const exportObjs = {
  Grid: SalonArtistGrid,
  GridItem: SalonArtistGridItem,
};

export default exportObjs;
